<div class="input-summary" (click)="this.onClick()" [title]="this.hedgeNamesTitle">
  <!-- CR-20260831-004: .changed = a field this chip summarises no longer matches the last run. -->
  <span class="chip" *ngFor="let c of this.chips" [class.changed]="c.changed">{{ c.text }}</span>
  <span class="edit-hint">Click to Edit</span>
</div>
